import React from 'react'

import HeaderPublic from '../../components/headerPublic/index.js'
import Footer from '../../components/footer/index.js'
import UserRegister from '../../components/userRegister/index.js'


const RegisterUser = () => {

    return (
        <div>
            <HeaderPublic />

            <UserRegister />

            <Footer />
        </div>
    );
}

export default RegisterUser;